var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpportunityHealthcareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3035 36.0092C13.5675 24.1508 23.1467 14.7252 35.018 14.9049C35.6747 14.9148 36.199 15.4558 36.189 16.1132C36.1791 16.7707 35.6387 17.2955 34.982 17.2856C24.443 17.126 15.9168 25.4862 15.6813 36.0622L14.4924 36.0357L15.6813 36.0622C15.5621 41.4529 17.7148 45.3828 20.799 49.6204L20.799 49.6204C21.4562 50.5235 22.0558 51.2257 22.6204 51.875C22.6758 51.9388 22.7313 52.0025 22.7867 52.0661C23.2867 52.6399 23.7821 53.2084 24.2335 53.8292C25.2812 55.2703 26.0627 56.9476 26.6527 59.9069C26.7812 60.5517 26.3633 61.1787 25.7192 61.3073C25.0751 61.436 24.4488 61.0177 24.3203 60.3729C23.7835 57.6803 23.1172 56.3399 22.3105 55.2303C21.9244 54.6993 21.4994 54.2112 20.9872 53.6231C20.9346 53.5626 20.881 53.501 20.8264 53.4382C20.2498 52.775 19.5959 52.0107 18.8767 51.0225C15.6878 46.641 13.167 42.1842 13.3035 36.0094L13.3035 36.0092Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3187 36.0621C54.0831 25.4861 45.5569 17.126 35.018 17.2856C34.3613 17.2955 33.8209 16.7707 33.8109 16.1132C33.801 15.4558 34.3253 14.9148 34.982 14.9049C46.8532 14.7252 56.4324 24.1508 56.6964 36.0092L56.6964 36.0094C56.833 42.1842 54.3121 46.641 51.1233 51.0225C50.4041 52.0107 49.7502 52.775 49.1736 53.4382C49.119 53.501 49.0654 53.5625 49.0127 53.623C48.5006 54.2112 48.0756 54.6993 47.6895 55.2303C46.8828 56.3399 46.2165 57.6803 45.6797 60.3729C45.5511 61.0177 44.9248 61.436 44.2808 61.3073C43.6367 61.1787 43.2188 60.5517 43.3473 59.9069C43.9373 56.9476 44.7188 55.2703 45.7665 53.8292C46.2179 53.2084 46.7132 52.6399 47.2132 52.0661C47.2687 52.0025 47.3241 51.9388 47.3796 51.875C47.9441 51.2257 48.5437 50.5235 49.201 49.6204L49.201 49.6204C52.2851 45.3828 54.4378 41.4527 54.3187 36.0621Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7014 60.0863C45.7326 60.743 45.2261 61.3007 44.5701 61.332L44.5076 61.335C44.4888 61.3359 44.4699 61.3363 44.4511 61.3363H25.7838C25.127 61.3363 24.5946 60.8033 24.5946 60.1458C24.5946 59.4883 25.127 58.9554 25.7838 58.9554H44.4228L44.457 58.9537C45.113 58.9225 45.6701 59.4295 45.7014 60.0863Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5135 58.9524C45.1702 58.9524 45.7026 59.4854 45.7026 60.1429V64.8661C45.7026 65.5236 45.1702 66.0565 44.5135 66.0565H25.4864C24.8297 66.0565 24.2972 65.5236 24.2972 64.8661C24.2972 64.2086 24.8297 63.6756 25.4864 63.6756H43.3243V60.1429C43.3243 59.4854 43.8567 58.9524 44.5135 58.9524Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5135 63.7143C45.1702 63.7143 45.7026 64.2473 45.7026 64.9048V69.6667C45.7026 70.3241 45.1702 70.8571 44.5135 70.8571H25.4864C24.8297 70.8571 24.2972 70.3241 24.2972 69.6667C24.2972 69.0092 24.8297 68.4762 25.4864 68.4762H43.3243V64.9048C43.3243 64.2473 43.8567 63.7143 44.5135 63.7143Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8561 68.6019C44.4436 68.8959 44.6817 69.611 44.3879 70.1991L40.8204 77.3419C40.6189 77.7452 40.2072 78 39.7567 78H35C34.3432 78 33.8108 77.467 33.8108 76.8095C33.8108 76.152 34.3432 75.619 35 75.619H39.0218L42.2607 69.1343C42.5544 68.5462 43.2687 68.3078 43.8561 68.6019Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 3C35.6568 3 36.1892 3.53299 36.1892 4.19048V9.25C36.1892 9.90748 35.6568 10.4405 35 10.4405C34.3432 10.4405 33.8108 9.90748 33.8108 9.25V4.19048C33.8108 3.53299 34.3432 3 35 3Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3964 7.98937C24.0032 7.73784 24.6988 8.02638 24.9501 8.63384L25.8598 10.8332C26.1111 11.4407 25.8229 12.1371 25.216 12.3886C24.6092 12.6401 23.9136 12.3516 23.6624 11.7441L22.7526 9.54473C22.5014 8.93727 22.7896 8.24091 23.3964 7.98937Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98397 24.4196C7.23523 23.8121 7.93083 23.5236 8.53764 23.7751L10.7347 24.6858C11.3415 24.9373 11.6297 25.6337 11.3784 26.2412C11.1272 26.8486 10.4316 27.1372 9.82477 26.8856L7.62774 25.9749C7.02093 25.7234 6.7327 25.027 6.98397 24.4196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3784 45.8303C11.6297 46.4377 11.3415 47.1341 10.7347 47.3856L8.53764 48.2963C7.93083 48.5479 7.23523 48.2593 6.98397 47.6519C6.7327 47.0444 7.02093 46.348 7.62774 46.0965L9.82477 45.1858C10.4316 44.9343 11.1272 45.2228 11.3784 45.8303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6215 45.8303C58.8728 45.2228 59.5684 44.9343 60.1752 45.1858L62.3722 46.0965C62.979 46.348 63.2673 47.0444 63.016 47.6519C62.7647 48.2593 62.0691 48.5479 61.4623 48.2963L59.2653 47.3856C58.6585 47.1341 58.3703 46.4377 58.6215 45.8303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.016 24.4196C63.2673 25.027 62.979 25.7234 62.3722 25.9749L60.1752 26.8856C59.5684 27.1372 58.8728 26.8486 58.6215 26.2412C58.3703 25.6337 58.6585 24.9373 59.2653 24.6858L61.4623 23.7751C62.0691 23.5236 62.7647 23.8121 63.016 24.4196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6036 7.98937C47.2104 8.24091 47.4987 8.93727 47.2474 9.54473L46.3377 11.7441C46.0864 12.3516 45.3908 12.6401 44.784 12.3886C44.1772 12.1371 43.889 11.4407 44.1402 10.8332L45.0499 8.63384C45.3012 8.02638 45.9968 7.73784 46.6036 7.98937Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6656 12.6761C12.13 12.2111 12.8829 12.2111 13.3473 12.6761L16.9208 16.2534C17.3853 16.7184 17.3853 17.4721 16.9208 17.937C16.4564 18.4019 15.7035 18.4019 15.2391 17.937L11.6656 14.3596C11.2012 13.8947 11.2012 13.141 11.6656 12.6761Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 36.0357C2 35.3782 2.53242 34.8452 3.18919 34.8452H8.24324C8.90001 34.8452 9.43243 35.3782 9.43243 36.0357C9.43243 36.6932 8.90001 37.2262 8.24324 37.2262H3.18919C2.53242 37.2262 2 36.6932 2 36.0357Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9208 54.1344C17.3853 54.5993 17.3853 55.3531 16.9208 55.818L13.3473 59.3954C12.8829 59.8603 12.13 59.8603 11.6656 59.3954C11.2012 58.9305 11.2012 58.1767 11.6656 57.7118L15.2391 54.1344C15.7035 53.6695 16.4564 53.6695 16.9208 54.1344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0791 54.1344C53.5435 53.6695 54.2965 53.6695 54.7609 54.1344L58.3344 57.7118C58.7988 58.1767 58.7988 58.9305 58.3344 59.3954C57.87 59.8603 57.1171 59.8603 56.6527 59.3954L53.0791 55.818C52.6147 55.3531 52.6147 54.5993 53.0791 54.1344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5676 36.0357C60.5676 35.3782 61.1 34.8452 61.7568 34.8452H66.8109C67.4676 34.8452 68.0001 35.3782 68.0001 36.0357C68.0001 36.6932 67.4676 37.2262 66.8109 37.2262H61.7568C61.1 37.2262 60.5676 36.6932 60.5676 36.0357Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3344 12.6761C58.7988 13.141 58.7988 13.8947 58.3344 14.3596L54.7609 17.937C54.2965 18.4019 53.5435 18.4019 53.0791 17.937C52.6147 17.4721 52.6147 16.7184 53.0791 16.2534L56.6527 12.6761C57.1171 12.2111 57.87 12.2111 58.3344 12.6761Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5931 23.6089C41.9435 23.0528 42.6778 22.8864 43.2333 23.2372C46.8508 25.5215 49.4577 29.267 50.2217 33.6526C50.3346 34.3003 49.9015 34.917 49.2545 35.0299C48.6075 35.1429 47.9916 34.7094 47.8787 34.0617C47.2335 30.358 45.0302 27.1869 41.9644 25.2509C41.409 24.9002 41.2427 24.165 41.5931 23.6089Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_22_308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 66,
    height: 75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3H2V78H68V3Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_22_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5223 73.3638C29.1097 73.0697 29.824 73.3081 30.1177 73.8962L30.9782 75.6191H35C35.6568 75.6191 36.1892 76.152 36.1892 76.8095C36.1892 77.467 35.6568 78 35 78H30.2433C29.7928 78 29.3811 77.7452 29.1796 77.3419L27.9904 74.961C27.6967 74.3729 27.9348 73.6578 28.5223 73.3638Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 75,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunityHealthcareIcon);
export default __webpack_public_path__ + "static/media/opportunity-healthcare-icon.b2e8621a1b4c00d21ca8185a71eecadf.svg";
export { ForwardRef as ReactComponent };